import styled from 'styled-components';
import { Slider } from 'antd';

const BasicSliderSection = styled.div`
  width: 100%;
  min-width: 300px;
`;

const SliderDescription = styled.div`
  font-family: Sofia Pro;
  font-size: 16px;
  line-height: 23px;
  color: ${props => props.descriptionColor};
  width: 100%;
  text-align: center;
  font-weight: 600;
`;

const StyledSlider = styled(Slider)`
  .ant-slider {
    margin: 18px 0px 18px;
  }

  .ant-slider-rail {
    background-color: ${props => props.railColor};
    border-radius: 4px;
  }

  .ant-slider-track {
    background-color: ${props => props.trackColor};
    border-radius: 4px;
  }

  .ant-slider-handle {
    border: none;
    background-color: ${props => props.trackColor};
    width: 24px;
    height: 24px;
    margin-top: -10px;

    &:focus {
      box-shadow: none;
      -webkit-box-shadow: none;
    }
  }
`;

export { BasicSliderSection, SliderDescription, StyledSlider };
